import Component from './abstract_component';
import $ from 'jquery';

class ProductCards extends Component {
  constructor() {
    super();
    this.cards = $('.wp-block-pluss-product-card');
  }

  _isReady() {
    return !!this.cards.length;
  }

  _run() {
    this.cards.each((index, item) => {
      const $this = $(item);
      const $preHeading = $this.find('.wp-block-pluss-product-card__prehead');
      const $readMoreLink = $this.find('.wp-block-pluss-link a');
      const $cardLink = $this.find('.wp-block-pluss-product-card__overlay-link');

      if ($preHeading.text().trim()) {
        $preHeading.addClass('show-icon')
      }

      if($readMoreLink.length && $cardLink.length) {
        $cardLink[0].href = $readMoreLink[0].href;
      }
    })
  }
}

export default ProductCards;
